import { getOriginalFileName } from "utils/string";

export const CURRENCY_TYPES = ["CNY", "USD"];

const CompaniesView = ({ companies }) => {
  return (
    <div className="card">
      <h5>Company Information 企业信息</h5>

      {companies ? (
        <div className="space-y-6">
          {companies.map((company, index) => (
            <div className="mt-4 -mx-2" key={index}>
              <table>
                <tbody>
                  <tr className="border-b border-gray-100 dark:border-gray-700">
                    <td colSpan={2}>
                      <h5>
                        公司 #{index + 1}: {company.name}
                      </h5>
                    </td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Business Type 业务类型</label>
                    </td>
                    <td className="w-full">
                      {company.businessType === "FOREIGN" ? "外贸" : "内销"}
                    </td>
                  </tr>

                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Register Address 注册地址:</label>
                    </td>
                    <td className="whitespace-pre-wrap">{company.address}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Type 公司类型:</label>
                    </td>
                    <td>{company.type}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Tax Number 税号:</label>
                    </td>
                    <td>{company.taxNumber}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Business License 营业执照:</label>
                    </td>
                    <td className=" space-y-1">
                      {company.businessLicense.map((url, lIndex) => (
                        <div
                          key={lIndex}
                          className="flex items-center space-x-2 text-xs"
                        >
                          <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="underline"
                          >
                            {getOriginalFileName(url)}
                          </a>
                        </div>
                      ))}
                    </td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Accepted Currency 接受货币:</label>
                    </td>
                    <td>
                      <div>
                        {(company.acceptedCurrencies
                          ? CURRENCY_TYPES.filter(
                              (currency) =>
                                company.acceptedCurrencies[currency],
                            )
                          : []
                        ).join(", ")}
                      </div>
                    </td>
                  </tr>

                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Payee Name 收款人名称:</label>
                    </td>
                    <td>{company.payeeName}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Payee Account 收款人帐号:</label>
                    </td>
                    <td>{company.payeeBankAccountNumber}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Payee Bank Branch 收款人银行分行:</label>
                    </td>
                    <td>{company.payeeBankBranchInfo}</td>
                  </tr>
                  <tr className="border-y border-gray-100 dark:border-gray-700">
                    <td>
                      <label>Payee Bank Branch 收款人银行地址:</label>
                    </td>
                    <td>{company.payeeBankAddress}</td>
                  </tr>

                  {company.businessType === "FOREIGN" && (
                    <tr className="border-y border-gray-100 dark:border-gray-700">
                      <td>
                        <label>SWIFT CODE / SWIFT代码:</label>
                      </td>
                      <td className="w-full">{company.swiftCode || "-"}</td>
                    </tr>
                  )}

                  {company.businessType === "DOMESTIC" && (
                    <tr className="border-y border-gray-100 dark:border-gray-700">
                      <td>
                        <label>Invoice Type 发票类型:</label>
                      </td>
                      <td className="w-full">
                        {company.invoiceType === "NORMAL" ? "普票" : "专票"}{" "}
                        (税点: {company.taxPercent})
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-500 mt-2">No companies available.</div>
      )}
    </div>
  );
};

export default CompaniesView;
